import React from 'react';
import { IconProps } from '../../types/icon';

const ExcelAltIcon: React.FC<IconProps> = ({ className, size = 16 }) => {
  return (
    <img
      src="/gitex-illustrations/ExcelAltIcon.png"
      alt="Excel Spreadsheet"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
};

export default ExcelAltIcon;
